/**
 * Employee service: list/get/create/update/delete.
 */
import type { Employee, CreateEmployeeRequest, UpdateEmployeeRequest } from '@monitor/shared'
import { httpClient } from '@/lib/axios'

export interface ListParams {
  page?: number
  pageSize?: number
  department?: string
  isActive?: boolean
  search?: string
}

export const employeeService = {
  async list(params: ListParams = {}): Promise<{ items: Employee[]; total: number }> {
    const r = await httpClient.get<{ items: Employee[]; total: number }>('/api/employees', {
      params,
    })
    return r.data
  },
  async get(id: number): Promise<Employee> {
    const r = await httpClient.get<Employee>(`/api/employees/${id}`)
    return r.data
  },
  async create(data: CreateEmployeeRequest): Promise<Employee> {
    const r = await httpClient.post<Employee>('/api/employees', data)
    return r.data
  },
  async update(id: number, data: UpdateEmployeeRequest): Promise<Employee> {
    const r = await httpClient.put<Employee>(`/api/employees/${id}`, data)
    return r.data
  },
  async delete(id: number): Promise<void> {
    await httpClient.delete(`/api/employees/${id}`)
  },
  async screenshots(
    id: number,
    params: { from?: string; to?: string; page?: number; pageSize?: number } = {},
  ) {
    const r = await httpClient.get(`/api/employees/${id}/screenshots`, { params })
    return r.data as {
      items: Array<{
        id: number
        capturedAt: string
        url: string
        width: number
        height: number
        fileSize: number
      }>
      total: number
      page: number
      pageSize: number
    }
  },
  async activity(id: number, params: { from?: string; to?: string; pageSize?: number } = {}) {
    const r = await httpClient.get(`/api/employees/${id}/activity`, { params })
    return r.data as {
      items: Array<{
        id: number
        loggedAt: string
        appName: string | null
        windowTitle: string | null
        url: string | null
        isIdle: boolean
        idleSeconds: number
      }>
    }
  },
}
